<template>
  <div id="picture">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>培训考试&nbsp;/&nbsp;视频管理</span>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="视频列表" name="first">
          <div style="display: flex; flex-wrap: wrap; align-items: center">
            <Provinces @gain="gainSS" v-if="clearId"></Provinces>
            <el-input
              class="elinputs"
              v-model="beginData.title"
              placeholder="视频标题"
            ></el-input>
            <el-input
              class="elinputs"
              v-model="beginData.label"
              placeholder="标签"
            ></el-input>
            <!-- <el-input
              class="elinputs"
              v-model="beginData.id"
              placeholder=" 搜索编号"
            ></el-input> -->
            <el-select
              v-model="beginData.cid"
              placeholder="所属分类"
              class="elinputs"
            >
              <el-option
                v-for="item in cidList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="beginData.isshow"
              placeholder="是否显示"
              class="elinputs"
            >
              <el-option
                v-for="item in beginData.isShows"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-select
              v-model="beginData.istop"
              placeholder="是否置顶"
              class="elinputs"
            >
              <el-option
                v-for="item in beginData.isTops"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-button
              type="primary"
              element-loading-text="加载中..."
              element-loading-background="rgba(0, 0, 0, 0.4)"
              v-loading.fullscreen.lock="fullscreenLoading"
              @click="query"
              >查询</el-button
            >
            <el-button type="info" @click="reset">重置</el-button>
          </div>
          <div class="tit">
            <Reset @clkBtn="theBtn"></Reset>
            <Xlsx :name="formname"></Xlsx>
          </div>
          <el-table
            :data="tableData"
            @selection-change="handleSelectionChange"
            id="exportTab"
            border
            stripe
            style="width: 100%"
          >
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column
              type="index"
              label="序号"
              width="80"
              :index="1"
            ></el-table-column>
            <el-table-column
              prop="title"
              label="视频标题"
              width="240"
            ></el-table-column>
            <el-table-column min-width="110" label="封面图">
              <template slot-scope="scope">
                <viewer>
                  <img class="sfzimg" :src="imgUrl + scope.row.coverImage" />
                </viewer>
              </template>
            </el-table-column>
            <el-table-column label="视频预览" width="160">
              <template slot-scope="scope">
                <img
                  class="sfzimg"
                  :src="`${
                    imgUrl + scope.row.url.substring(5)
                  }?x-oss-process=video/snapshot,t_7000,f_jpg,w_800,h_600,m_fast`"
                  @click="lookvid(scope.row)"
                />
              </template>
            </el-table-column>
            <el-table-column
              prop="label"
              label="标签"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="cname"
              label="所属分类"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="areasName"
              label="所属地区"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="readFalse"
              label="浏览次数（假）"
              sortable
              min-width="180"
            ></el-table-column>
            <el-table-column
              prop="readTrue"
              label="浏览次数（真）"
              sortable
              min-width="180"
            ></el-table-column>

            <el-table-column label="是否显示" width="130">
              <template slot-scope="scope">
                <p class="boldfont" v-if="scope.row.isshow == 0">是</p>
                <p
                  class="boldfont"
                  v-if="scope.row.isshow == 1"
                  style="color: #f56c6c"
                >
                  否
                </p>
              </template>
            </el-table-column>
            <el-table-column label="是否置顶" width="130">
              <template slot-scope="scope">
                <p class="boldfont" v-if="scope.row.istop == 0">是</p>
                <p
                  class="boldfont"
                  v-if="scope.row.istop == 1"
                  style="color: #f56c6c"
                >
                  否
                </p>
              </template>
            </el-table-column>
            <el-table-column
              prop="createtime"
              sortable
              label="添加时间"
              min-width="180"
            ></el-table-column>
            <el-table-column
              prop="modifytime"
              sortable
              label="修改时间"
              min-width="180"
            ></el-table-column>
            <el-table-column label="操作" fixed="right" min-width="180">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="success"
                  @click="handleEdit(2, scope.row, 'footage:update')"
                  ><i class="el-icon-edit"></i> 编辑</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  @click="stop(scope.row, 'footage:delete')"
                  ><i class="el-icon-delete"></i> 删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="视频分类" name="second">
          <div style="display: flex; flex-wrap: wrap; align-items: center">
            <Provinces @gain="gainSSf" v-if="clearId"></Provinces>
            <el-input
              class="elinputs"
              v-model="beginData.cname"
              placeholder="分类名称"
            ></el-input>
            <!-- <el-input
              class="elinputs"
              v-model="beginData.ccode"
              placeholder=" 搜索编号"
            ></el-input> -->
            <el-select
              v-model="beginData.isshow"
              placeholder="是否显示"
              class="elinputs"
            >
              <el-option
                v-for="item in beginData.isShows"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-button
              type="primary"
              element-loading-text="加载中..."
              element-loading-background="rgba(0, 0, 0, 0.4)"
              v-loading.fullscreen.lock="fullscreenLoading"
              @click="query"
              >查询</el-button
            >
            <el-button type="info" @click="reset">重置</el-button>
          </div>
          <div class="tit">
            <Reset @clkBtn="theBtn"></Reset>
            <Xlsx :name="formname"></Xlsx>
          </div>
          <el-table
            :data="tableData2"
            @selection-change="handleSelectionChange"
            id="exportTab"
            border
            stripe
            style="width: 100%"
          >
            <el-table-column type="selection" width="60"></el-table-column>
            <el-table-column
              type="index"
              label="序号"
              width="80"
              :index="1"
            ></el-table-column>
            <el-table-column
              prop="name"
              label="分类名称"
              width="160"
            ></el-table-column>
            <el-table-column
              prop="areasName"
              label="所属地区"
              width="160"
            ></el-table-column>
            <el-table-column min-width="120" label=" 图标">
              <template slot-scope="scope">
                <viewer>
                  <img class="sfzimg" :src="imgUrl + scope.row.icon" />
                </viewer>
              </template>
            </el-table-column>
            <el-table-column
              prop="sort"
              label="排序"
              sortable
              width="120"
            ></el-table-column>
            <el-table-column label="是否显示" width="130">
              <template slot-scope="scope">
                <p class="boldfont" v-if="scope.row.cisshow == 0">是</p>
                <p
                  class="boldfont"
                  v-if="scope.row.cisshow == 1"
                  style="color: #f56c6c"
                >
                  否
                </p>
              </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" min-width="180">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  type="success"
                  @click="handleEdit(2, scope.row, 'footage:update')"
                  ><i class="el-icon-edit"></i>编辑</el-button
                >
                <el-button
                  size="mini"
                  type="danger"
                  @click="stop(scope.row, 'footage:delete')"
                  ><i class="el-icon-delete"></i>删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <div class="paging">
        <span
          >共<i class="pagingNum">{{ total }}</i> 条</span
        >
        <Paging :gopage="total" @pag="pag"></Paging>
      </div>
    </el-card>
    <el-dialog
      title="添加/编辑"
      :visible.sync="dialogFormVisible"
      @close="dataClose"
      width="60%"
    >
      <el-form v-if="activeName == 'first'">
        <el-form-item label="* 所属分类：">
          <el-select v-model="details.cid" placeholder="请选择">
            <el-option
              v-for="item in cidList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="* 所属地区：">
          <el-select
            v-model="sheng"
            placeholder="省份"
            @change="cksheng"
          >
            <el-option
              v-for="item in shenglist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="shi"
            placeholder="城市"
            @change="ckshi"
            class="cty16"
          >
            <el-option
              v-for="item in shilist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="* 视频标题：">
          <el-input
            placeholder="请输入视频标题"
            v-model="details.title"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="* 封面图：" style="margin-bottom: 10px">
          <el-upload
            class="upload-demo"
            :action="URL"
            :limit="1"
            :on-remove="handleRemove"
            :on-success="handleAvatarSuccess"
            :data="newobj"
            :file-list="details.cover"
            name="multipartFile"
            :headers="newhead"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              选择封面图，推荐尺寸600*600px，大小100k以内
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="* 视 频：" style="margin-bottom: 10px">
          <el-upload
            class="upload-demo"
            :on-preview="handlePreview"
            :action="videoURL"
            :limit="1"
            :on-remove="handleRemove1"
            :on-success="handleAvatarSuccess1"
            :data="newobj"
            ref="upload"
            :file-list="details.vid"
            name="multipartFile"
            :headers="newhead"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">选择视频</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="* 标 签：">
          <div>
            <el-tag
              :key="tag"
              v-for="tag in details.labels"
              closable
              :disable-transitions="false"
              @close="handleClose(tag)"
              >{{ tag }}</el-tag
            >
            <el-input
              class="input-new-tag"
              v-if="inputVisible"
              v-model="inputValue"
              ref="saveTagInput"
              size="small"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            ></el-input>
            <el-button
              v-else
              class="button-new-tag"
              size="small"
              @click="showInput"
              >添加标签(字数不能超过5个字)</el-button
            ><i class="tx">最多只能添加3个标签</i>
          </div>
        </el-form-item>
        <el-form-item label="* 浏览量（假）：">
          <el-input
            placeholder="浏览量（假）"
            v-model="details.readFalse"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="* 排 序：">
          <el-input
            placeholder="数字越大，排名越靠前（请输入正整数）"
            v-model="details.sort"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="* 是否显示：">
          <el-radio v-model="details.isshow" label="0">是</el-radio>
          <el-radio v-model="details.isshow" label="1">否</el-radio>
        </el-form-item>
        <el-form-item label="* 是否置顶：">
          <el-radio v-model="details.istop" label="0">是</el-radio>
          <el-radio v-model="details.istop" label="1">否</el-radio>
        </el-form-item>
      </el-form>
      <el-form v-else>
        <el-form-item label="* 分类名称：">
          <el-input
            placeholder="请输入分类名称"
            v-model="details.name"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="* 封面图：" style="margin-bottom: 10px">
          <el-upload
            class="upload-demo"
            :action="URL"
            :limit="1"
            :on-remove="handleRemove"
            :on-success="handleAvatarSuccess"
            :data="newobj"
            ref="uploads"
            :file-list="details.cover"
            name="multipartFile"
            :headers="newhead"
            list-type="picture"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              选择图标，推荐尺寸600*600px，大小100k以内
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="* 所属地区：">
          <el-select
            v-model="sheng"
            placeholder="省份"
            @change="cksheng"
          >
            <el-option
              v-for="item in shenglist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-select
            v-model="shi"
            placeholder="城市"
            @change="ckshi"
            class="cty16"
          >
            <el-option
              v-for="item in shilist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="* 排 序：">
          <el-input
            placeholder="数字越大，排名越靠前（请输入正整数）"
            v-model="details.sort"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="* 是否显示：">
          <el-radio v-model="details.cisshow" label="0">是</el-radio>
          <el-radio v-model="details.cisshow" label="1">否</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="puton">确 定</el-button>
      </div>
    </el-dialog>
    <el-drawer
      title="视频预览"
      :visible.sync="drawer"
      direction="ltr"
      size="50%"
      :before-close="handleCloseVideo"
    >
      <div class="cam_dra_top">
        <p class="cam_vid">
          <span>标题：{{ draData.title }}</span>
        </p>
        <p class="cam_vid">
          <span>标签：{{ draData.label }}</span
          ><span>所属分类：{{ draData.cname }}</span>
        </p>
      </div>
      <div style="width: 90%; margin: 2% auto 4%; height: 560px">
        <p id="playercontainer"></p>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import Xlsx from "@/components/Xlsx";
import EditorBar from "@/components/Richtext";
import Reset from "@/components/Reset";
import Paging from "@/components/Paging";
import Provinces from "@/components/Provinces";
export default {
  name: "footage",
  components: {
    Xlsx,
    EditorBar,
    Reset,
    Paging,
    Provinces,
  },
  data() {
    return {
      beginData: {
        isShows: [
          { id: 0, name: "是" },
          { id: 1, name: "否" },
        ],
        isTops: [
          { id: 0, name: "是" },
          { id: 1, name: "否" },
        ],
      },
      tableData: [],
      tableData2: [],
      pageNum: 1,
      pageSize: 10,
      dialogFormVisible: false,
      details: { labels: [], isshow: "0", istop: "0", cisshow: "cisshow" },
      userdata: {},
      total: 0,
      btn: [],
      fullscreenLoading: true,
      imgUrl: this.$Public.imgUrl,
      formname: JSON.stringify({ name: "视频管理", hint: "footage:export" }),
      cid: "",
      cidList: [],
      URL: `${this.$Public.URL}/api-r/upload/uploadImg`,
      videoURL: `${this.$Public.URL}/api-e/upload/uploadVideo`,
      newobj: { type: 2 },
      newhead: {
        accessToken: JSON.parse(sessionStorage.getItem("userdata")).token,
      },
      fileList2: [],
      videoList: "",
      inputVisible: false,
      inputValue: "",
      sheng: "",
      shengName: '',
      shi: "",
      shenglist: [],
      shilist: [],
      status: "",
      activeName: "first",
      vidImg: require("../../assets/img/1572256352(1).jpg"),
      drawer: false,
      draData: {},
      multipleSelection: [],
      beginIdfl: "",
      clearId: true,
    };
  },
  created() {
    let btn = JSON.parse(sessionStorage.getItem("btn"));
    this.$set(this, "btn", btn);
    let userdata = JSON.parse(sessionStorage.getItem("userdata"));
    this.beginIdfl = userdata.areasId;
    this.$set(this, "userdata", userdata);
    this.begin();
  },
  computed: {
    data() {
      return this.tableData;
    },
  },
  watch: {
    tableData2(newV) {
      // console.log(123321)
    },
  },
  mounted() {
    // 查询下拉框分类
    let data = this.$qs.stringify({
      areasId: this.userdata.areasId,
    });
    this.$axios
      .post(`/api-e/category/categoryV`, data, {
        headers: { accessToken: this.userdata.token },
      })
      .then((res) => {
        if (res.data.success) {
          this.cidList = res.data.categoryInfoList;
        }
      });
    let region = JSON.parse(localStorage.getItem("region"));
    region.forEach((x) => {
      if (x.level == 0) {
        this.shenglist.push(x);
        this.sheng = x.id;
        this.shengName = x.name;
      }
    });
    if (this.userdata.level == 0) {
      this.$axios
        .post(
          `/api-r/area/getSubordinateAreaList`,
          this.$qs.stringify({ areasId: region[0].id }),
          { headers: { accessToken: this.userdata.token } }
        )
        .then((res) => {
          if (res.data.success) {
            this.$set(this, "shilist", res.data.areaListInfoList);
          }
        });
    } else {
      region.forEach((x) => {
        if (x.level == 1) {
          this.shilist.push(x);
        }
      });
      if (this.shilist.length == 1) {
        this.shi = this.shilist[0].id;
        this.details.areasid = this.sheng + "," + this.shilist[0].id;
        this.details.areasName = this.shengName + "," + this.shilist[0].name;
      }
    }
  },
  methods: {
    handleCloseVideo(done) {
      this.player.remove();
      done();
    },
    //   判断当前点击的按钮
    theBtn(i) {
      if (i == 1) {
        if (this.btn.indexOf("footage:add") == -1) {
          return this.$message("抱歉，用户暂无该权限");
        }
        this.handleEdit(1);
      } else if (i == 2) {
        if (this.btn.indexOf("footage:update") == -1) {
          return this.$message("抱歉，用户暂无该权限");
        }
        if (this.multipleSelection.length != 1) {
          return this.$message("请勾选一项内容编辑");
        }
        this.handleEdit(2, this.multipleSelection[0]);
      } else if (i == 3) {
        if (this.btn.indexOf("footage:delete") == -1) {
          return this.$message("抱歉，用户暂无该权限");
        }
        this.choice();
      } else if (i == 4) {
        this.query();
      }
    },
    //   多选编辑
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    //   多选删除
    choice() {
      if (this.multipleSelection.length == 0) {
        return this.$message("请至少选择一项删除");
      }
      let arr = [];
      this.multipleSelection.forEach((x) => {
        arr.push(x.id);
      });
      this.$confirm("此操作将删除选中内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let url = ``;
          if (this.activeName == "first") {
            url = `/api-e/video/deleteVideo/${arr.join(",")}`;
          } else {
            url = `/api-e/category/deleteCategory/${arr.join(",")}`;
          }
          this.$axios
            .post(url, {}, { headers: { accessToken: this.userdata.token } })
            .then((res) => {
              if (res.data.success == true) {
                this.$message({
                  type: "success",
                  message: res.data.msg,
                });
                this.begin();
              } else {
                alert(res.data.msg);
              }
            });
        })
        .catch(() => {
          return;
        });
    },
    //视频查看
    lookvid(row) {
      const _this = this;
      _this.drawer = true;
      _this.draData = row;
      this.$nextTick(() => {
        _this.player = cyberplayer("playercontainer").setup({
          width: "100%", // 宽度，也可以支持百分比（不过父元素宽度要有）
          height: "100%", // 高度，也可以支持百分比
          title: row.position, // 标题
          isLive: true, // 必须设置，表明是直播视频
          file: this.imgUrl + row.url.substring(5), // //您的视频源的地址（目前是乐橙示例播放地址）
          image: "", // 预览图
          autostart: false, // 是否自动播放
          stretching: "uniform", // 拉伸设置
          repeat: false, // 是否重复播放
          volume: 0, // 音量，注：仅当用户同意、网站由用户激活或媒体无声时允许自动播放
          controls: true, // 是否显示控制栏
          starttime: 0,
          hls: {
            reconnecttime: 5, // hls直播重连间隔秒数
          },
          ak: "39f82ac87fc3462ea4dcc78734450f57", // 百度智能云平台注册（https://cloud.baidu.com）即可获得accessKey
        });
      });
    },
    handlePreview(file) {
      window.open(file.vidUrl, "_blank");
    },
    handleClick(tab, event) {
      if (this.activeName == "first") {
        this.begin();
      } else {
        this.classify();
      }
    },
    // 视频分类列表获取
    classify() {
      let data2 = this.$qs.stringify({
        areasId: this.beginIdfl,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ccode: this.beginData.ccode,
        cname: this.beginData.cname,
        isShow: this.beginData.isshow,
      });
      this.$axios
        .post(`/api-e/category/categoryListV`, data2, {
          headers: { accessToken: this.userdata.token },
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.success) {
            this.$nextTick(function () {
              //不使用this.$nextTick()方法会报错
              // this.tableData2 = res.data.pageInfo.list
              this.$set(this, "tableData2", res.data.pageInfo.list);
              this.$forceUpdate();
            });
            this.$set(this, "total", res.data.pageInfo.total);
            this.$message({
              type: "success",
              message: res.data.msg,
            });
          }
        });
    },
    // 关闭清空内容
    dataClose() {
      if (this.shilist.length == 1) {
        this.details = {
          labels: [],
          isshow: "0",
          istop: "0",
          cisshow: "cisshow",
          areasid: this.sheng + "," + this.shilist[0].id,
        };
      } else {
        this.shi = "";
        this.details = {
          labels: [],
          isshow: "0",
          istop: "0",
          cisshow: "cisshow",
        };
      }
    },
    change(val) {
      console.log(val);
    },
    // 提交
    puton() {
      if (this.details.areasid == undefined || this.details.areasid == "") {
        return this.$message("请选择所属地区");
      }
      let url = "";
      if (this.activeName == "first") {
        this.details.coverImage = this.fileList2.join(",");
        const label = this.details.labels.join(",");
        this.details.label = label;
        if (this.status == 1) {
          url = `/api-e/video/addVideo`;
        } else if (this.status == 2) {
          url = `api-e/video/updateVideo`;
        }
      } else {
        this.details.icon = this.fileList2.join(",");
        if (this.status == 1) {
          url = `/api-e/category/addVideoCategory`;
        } else if (this.status == 2) {
          url = `/api-e/category/updateCategory`;
        }
      }
      this.fullscreenLoading = true;
      this.$axios
        .post(url, this.$qs.stringify(this.details), {
          headers: { accessToken: this.userdata.token },
        })
        .then((res) => {
          this.dialogFormVisible = false;
          if (this.status == 1) {
            this.begin();
          } else if (this.status == 2) {
            this.classify();
          }
          this.$refs.upload.clearFiles();
          this.$refs.uploads.clearFiles();
        });
    },
    // 地区id
    cksheng(val) {
      this.$set(this, "shi", "");
    },
    ckshi(val) {
      this.details.areasid = this.sheng + "," + val;
      let addName = "";
      this.shilist.forEach((x) => {
        if (val == x.id) {
          addName = x.name;
        }
      });
      this.details.areasName = this.shenglist[0].name + "," + addName;
    },
    // 点击添加标签
    handleClose(tag) {
      this.details.labels.splice(this.details.labels.indexOf(tag), 1);
    },
    showInput() {
      if (this.details.labels.length > 2) {
        return this.$message("最多添加3个标签");
      }
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.details.labels.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    // 封面图处理
    handleRemove(file, fileList) {
      if (fileList.length > 0) {
        let newarr = [];
        fileList.forEach((x) => {
          newarr.push(x.response.url);
        });
        this.fileList2 = newarr;
      } else {
        this.fileList2 = [];
      }
    },
    // 视频哇
    handleRemove1(file, fileList) {
      this.details.url = "";
    },
    handleAvatarSuccess(res, file) {
      this.fileList2.push(res.url);
    },
    handleAvatarSuccess1(res, file) {
      this.details.vid = [
        {
          name: "视频",
          url: `${
            this.imgUrl +
            "images/knowledge/898a8004-c395-495e-afc3-100d7c3d742e.jpg"
          }`,
        },
      ];
      this.details.url = res.url;
    },
    reset() {
      this.beginData = {
        isShows: [
          { id: 0, name: "是" },
          { id: 1, name: "否" },
        ],
        isTops: [
          { id: 0, name: "是" },
          { id: 1, name: "否" },
        ],
      };
      this.clearId = false;
      this.$nextTick(function () {
        this.clearId = true;
      });
      if (this.activeName == "first") {
        this.begin();
      } else {
        this.beginIdfl = this.userdata.areasId;
        this.classify();
      }
    },
    pag(val) {
      this.pageNum = val.pageNum;
      this.pageSize = val.pageSize;
      this.fullscreenLoading = true;
      this.begin();
    },
    // 获取省市传入的id
    gainSS(i) {
      this.beginData.areasId = i.id;
    },
    gainSSf(i) {
      this.beginIdfl = i.id;
    },
    begin() {
      let data = this.$qs.stringify({
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        id: this.beginData.id,
        cid: this.beginData.cid,
        isshow: this.beginData.isshow,
        istop: this.beginData.istop,
        label: this.beginData.label,
        title: this.beginData.title,
        areasid: this.userdata.areasId,
        areaId: this.beginData.areasId,
      });
      this.$axios
        .post(`/api-e/video/videoLists`, data, {
          headers: { accessToken: this.userdata.token },
        })
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.success) {
            this.$nextTick(function () {
              //不使用this.$nextTick()方法会报错
              this.$set(this, "tableData", res.data.pageInfo.list);
            });
            this.$set(this, "total", res.data.pageInfo.total);
            this.$message({
              type: "success",
              message: res.data.msg,
            });
          } else {
            this.$message(res.data.msg);
          }
        });
    },
    handleEdit(i, row, hint) {
      if (hint && this.btn.indexOf(hint) == -1) {
        return this.$message("抱歉，用户暂无该权限");
      }
      this.status = i;
      this.fileList2 = [];
      if (i == 2) {
        if (this.activeName == "first") {
          this.$axios
            .post(
              `/api-e/video/getVideo/${row.id}`,
              {},
              { headers: { accessToken: this.userdata.token } }
            )
            .then((res) => {
              res.data.cid = Number(res.data.cid);
              res.data.isshow += "";
              res.data.istop += "";
              this.fileList2.push(res.data.coverImage);
              res.data.cover = [
                { name: "封面图", url: `${this.imgUrl + res.data.coverImage}` },
              ];
              let vidUrl = this.imgUrl + res.data.url.substring(5);
              // res.data.vid = [{name:'视频',url:`${this.imgUrl+'images/knowledge/898a8004-c395-495e-afc3-100d7c3d742e.jpg'}`,vidUrl:vidUrl}]
              res.data.vid = [
                { name: "视频", url: `${this.vidImg}`, vidUrl: vidUrl },
              ];
              res.data.labels = res.data.label.split(",");
              this.sheng = Number(res.data.areasid.split(",")[0]);
              this.shi = Number(res.data.areasid.split(",")[1]);
              this.$set(this, "details", res.data);
            });
        } else {
          this.$axios
            .post(
              `/api-e/category/getCategoryById/${row.id}`,
              {},
              { headers: { accessToken: this.userdata.token } }
            )
            .then((res) => {
              res.data.cisshow += "";
              this.fileList2.push(res.data.coverImage);
              res.data.cover = [
                { name: "封面图", url: `${this.imgUrl + res.data.icon}` },
              ];
              this.sheng = Number(res.data.areasid.split(",")[0]);
              this.shi = Number(res.data.areasid.split(",")[1]);
              this.$set(this, "details", res.data);
            });
        }
      }
      this.dialogFormVisible = true;
      //   this.$set(this, "information", i);
    },
    stop(row, hint) {
      if (hint && this.btn.indexOf(hint) == -1) {
        return this.$message("抱歉，用户暂无该权限");
      }
      this.$confirm("此操作将删除该条内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let url = ``;
          if (this.activeName == "first") {
            url = `/api-e/video/deleteVideo/${row.id}`;
          } else {
            url = `/api-e/category/deleteCategory/${row.id}`;
          }
          this.$axios
            .post(url, {}, { headers: { accessToken: this.userdata.token } })
            .then((res) => {
              if (res.data.success == true) {
                this.$message({
                  type: "success",
                  message: res.data.msg,
                });
                if (this.activeName == "first") {
                  this.begin();
                } else {
                  this.classify();
                }
              } else {
                alert(res.data.msg);
              }
            });
        })
        .catch(() => {
          return;
        });
    },
    query() {
      this.fullscreenLoading = true;
      if (this.activeName == "first") {
        this.begin();
      } else {
        this.classify();
      }
    },
  },
};
</script>
<style>
.cam_vid{
    width: 90%;
    margin: 0 auto;
    display: flex;
}
.cam_dra_top{
    line-height: 38px;
}
.cam_dra_top>.cam_vid:last-child>span:first-child{
  width: 50%
}
.w-e-toolbar {
  flex-wrap: wrap;
}
#picture .el-input__inner {
  margin: 10px 0;
}
#picture .el-menu.el-menu--horizontal {
  margin-bottom: 14px;
}
#picture .el-menu-item.is-active {
  background: none;
}
#picture .el-pagination__sizes .el-input__inner {
  margin: 0;
}
#picture .el-tag {
  margin-right: 12px;
}
#picture .el-select {
  /* margin: 0 8px; */
  width: 100%;
}
#picture .el-upload__tip {
  display: inline-block;
  margin-left: 14px;
}
.input-new-tag {
  width: 20%;
}
#picture .el-upload-list--picture .el-upload-list__item {
  width: 44%;
  float: left;
  margin-right: 2%;
}
#picture .el-form-item__content {
  width: 100%;
}
#picture .el-table td,
.el-table th.is-leaf {
  text-align: center;
}
/* 暂无数据样式 */
#picture .el-table__empty-text {
  display: block;
  width: 500px;
  height: 240px;
  padding-top: 126px;
  background: url(../../assets/img/nothing.svg) no-repeat 50%;
  color: #909399;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 12px;
}
#picture .myxx .el-input--suffix .el-input__inner {
  border-bottom: 1px solid #dcdfe6;
  margin-bottom: 20px;
}
#picture .myxx .el-input__inner {
  padding: 0 11px;
  border: none;
  border-radius: 0;
}
#picture .el-dialog__body {
  height: 382px;
}
#nei .el-dialog__body {
  height: 150px !important;
}
#picture .el-form-item {
  display: flex;
  align-items: center;
  margin-bottom: 0;
}
#picture .el-form-item__content {
    width: 100%;
    display: flex;
    align-items: center;
}
#picture .el-form-item__label {
  width: 160px;
}
.viewer-transition {
  z-index: 9999 !important;
}
</style>
<style scoped lang="scss">
.clearfix {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tit {
  display: flex;
  justify-content: space-between;
  margin: 16px 0 24px;
}
.sfzimg {
  height: 48px;
}
#help .myxx p {
  margin: 5px 0;
  font-size: 16px;
}
h5 {
  text-align: center;
  margin-top: 12px;
}
.f56 {
  background: #909399;
  color: #fff;
  border: 1px solid #909399;
}
.c23 {
  background: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
.tx {
  color: red;
  margin-left: 8px;
}
</style>
